import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { MOBILE_APP } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
class MobileAppGuardService {
  constructor(private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable((observer) => {
      window.location.href = navigator.userAgent.match(/iPhone|iPad/i) ? MOBILE_APP.appStore : MOBILE_APP.playStore;
      observer.next(this.router.parseUrl('/'));
    });
  }
}

export const MobileAppGuard: CanActivateFn = (): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  return inject(MobileAppGuardService).canActivate();
};
